import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ElementsDataService from '../../api/entitiesDataServices/ElementsDataService.js'
import AuthenticationService from '../general/AuthenticationService.js'

const PAGE_SIZE = 25

class ClienteComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            ...props,
            busqueda: '',
            currentPage: 1,
            sortKey: 'nombreCliente',
            sortAsc: true,
        }
        this.sortBy = this.sortBy.bind(this)
    }

    componentDidMount() {
        if (!AuthenticationService.haveAuthorization("READ_CLIENTES")) {
            alert("Usuario no autorizado")
            this.props.history.push('/login')
            return
        }
        this.props.refreshElements()
    }

    doSort(key, asc, arr) {
        return [...arr].sort((a, b) => {
            const va = (a[key] || '').toString().trim().toUpperCase()
            const vb = (b[key] || '').toString().trim().toUpperCase()
            if (va < vb) return asc ? -1 : 1
            if (va > vb) return asc ? 1 : -1
            return 0
        })
    }

    sortBy(key) {
        const asc = this.state.sortKey === key ? !this.state.sortAsc : true
        const sorted = this.doSort(key, asc, this.state.elements || [])
        this.setState({ elements: sorted, sortKey: key, sortAsc: asc, currentPage: 1 })
    }

    onBusqueda(value) {
        const val = value.toUpperCase()
        this.setState({ busqueda: val, currentPage: 1 })
        if (val.length > 2) {
            ElementsDataService.retrieveSearch(val, "clientes")
                .then(r => this.setState({ elements: r.data }))
        } else if (val.length === 0) {
            this.props.refreshElements()
        }
    }

    render() {
        const { busqueda, currentPage, sortKey, sortAsc } = this.state
        const elements = this.state.elements || []
        const totalPages = Math.max(1, Math.ceil((elements.length + 1) / PAGE_SIZE))
        const page = Math.min(currentPage, totalPages)

        // Row 0 = TODOS (fijo), luego paginados
        const allRows = [{ id: 0, nombreCliente: 'TODOS', propietario: '', _todos: true }, ...elements]
        const pageData = allRows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

        const SortIcon = ({ k }) => {
            if (sortKey !== k) return <span style={{ color: '#cbd5e1', marginLeft: 4 }}>↕</span>
            return <span style={{ color: '#3b82f6', marginLeft: 4 }}>{sortAsc ? '↑' : '↓'}</span>
        }

        const propietarioBadge = (p) => {
            if (!p) return null
            const colors = {
                ST:  { background: '#eff6ff', color: '#2563eb', borderColor: '#bfdbfe' },
                SPH: { background: '#f0fdf4', color: '#16a34a', borderColor: '#bbf7d0' },
            }
            const c = colors[p] || { background: '#f1f5f9', color: '#475569', borderColor: '#e2e8f0' }
            return (
                <span style={{ ...badgeStyle, ...c }}>{p}</span>
            )
        }

        return (
            <div style={styles.root}>
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
                    .cli-root * { font-family: 'Inter', sans-serif; box-sizing: border-box; }
                    .cli-input {
                        width: 100%; padding: 9px 14px 9px 38px;
                        background: white; border: 1px solid #e2e8f0; border-radius: 10px;
                        font-size: 0.84rem; color: #334155; outline: none;
                        transition: all 0.2s; font-family: 'Inter', sans-serif;
                    }
                    .cli-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.1); }
                    .cli-th {
                        padding: 10px 16px; text-align: left;
                        font-size: 0.7rem; font-weight: 700; color: #64748b;
                        letter-spacing: 0.8px; text-transform: uppercase;
                        border-bottom: 1px solid #e2e8f0; background: #f8fafc;
                        white-space: nowrap; user-select: none;
                    }
                    .cli-th.sortable { cursor: pointer; }
                    .cli-th.sortable:hover { color: #3b82f6; background: #f0f7ff; }
                    .cli-tr { border-bottom: 1px solid #f1f5f9; transition: background 0.15s; }
                    .cli-tr:hover td { background: #f8faff !important; }
                    .cli-td { padding: 11px 16px; font-size: 0.83rem; color: #334155; vertical-align: middle; }
                    .cli-link { color: #3b82f6; text-decoration: none; font-weight: 600; }
                    .cli-link:hover { text-decoration: underline; }
                    .btn-edit {
                        padding: 5px 10px; border: 1px solid #e2e8f0;
                        border-radius: 7px; background: white; cursor: pointer;
                        font-size: 0.75rem; color: #64748b; transition: all 0.15s;
                    }
                    .btn-edit:hover { border-color: #3b82f6; color: #3b82f6; background: #eff6ff; }
                    .btn-del {
                        padding: 5px 10px; border: 1px solid #fee2e2;
                        border-radius: 7px; background: white; cursor: pointer;
                        font-size: 0.75rem; color: #ef4444; transition: all 0.15s;
                    }
                    .btn-del:hover { background: #fef2f2; border-color: #ef4444; }
                    .page-btn {
                        min-width: 34px; height: 34px; padding: 0 10px;
                        border: 1px solid #e2e8f0; border-radius: 8px;
                        background: white; cursor: pointer; font-size: 0.82rem;
                        color: #475569; transition: all 0.15s; font-family: 'Inter', sans-serif;
                        display: flex; align-items: center; justify-content: center;
                    }
                    .page-btn:hover:not(:disabled) { border-color: #3b82f6; color: #3b82f6; }
                    .page-btn.active { background: #3b82f6; color: white; border-color: #3b82f6; font-weight: 700; }
                    .page-btn:disabled { opacity: 0.4; cursor: not-allowed; }
                    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                    .cli-table-wrap { animation: fadeIn 0.3s ease; }
                `}</style>

                <div className="cli-root" style={styles.inner}>

                    {/* Header */}
                    <div style={styles.pageHeader}>
                        <div>
                            <h1 style={styles.pageTitle}>Proyectos</h1>
                            <p style={styles.pageSubtitle}>{elements.length} proyecto{elements.length !== 1 ? 's' : ''} registrado{elements.length !== 1 ? 's' : ''}</p>
                        </div>
                        {AuthenticationService.haveAuthorization("WRITE_CLIENTES") && (
                            <button style={styles.btnAdd} onClick={this.props.addElementClicked}>
                                + Nuevo Proyecto
                            </button>
                        )}
                    </div>

                    {/* Buscador */}
                    <div style={styles.searchWrap}>
                        <div style={{ position: 'relative' }}>
                            <span style={styles.searchIcon}>🔍</span>
                            <input
                                className="cli-input"
                                type="text"
                                placeholder="Buscar proyecto..."
                                value={busqueda}
                                onChange={e => this.onBusqueda(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Tabla */}
                    <div style={styles.tableCard} className="cli-table-wrap">
                        <div style={{ overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th className="cli-th" style={{ width: 50, textAlign: 'center' }}>#</th>
                                        <th className="cli-th sortable" onClick={() => this.sortBy('nombreCliente')}>
                                            Nombre Proyecto <SortIcon k="nombreCliente" />
                                        </th>
                                        <th className="cli-th sortable" style={{ textAlign: 'center' }} onClick={() => this.sortBy('propietario')}>
                                            Propietario <SortIcon k="propietario" />
                                        </th>
                                        <th className="cli-th" style={{ width: 50, textAlign: 'center' }}></th>
                                        {AuthenticationService.haveAuthorization("DELETE_CLIENTES") && (
                                            <th className="cli-th" style={{ width: 50, textAlign: 'center' }}></th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {pageData.map((el, i) => {
                                        const n = (page - 1) * PAGE_SIZE + i
                                        return (
                                            <tr key={el.id} className="cli-tr">
                                                <td className="cli-td" style={{ textAlign: 'center', color: '#94a3b8', fontWeight: 600 }}>
                                                    {el._todos ? <span style={{ fontSize: '0.7rem', color: '#94a3b8' }}>—</span> : n}
                                                </td>
                                                <td className="cli-td">
                                                    <Link to={`/clientes/reportes/${el.id}`} className="cli-link">
                                                        {el.nombreCliente}
                                                    </Link>
                                                    {el._todos && (
                                                        <span style={{ marginLeft: 8, fontSize: '0.7rem', background: '#f1f5f9', color: '#94a3b8', border: '1px solid #e2e8f0', borderRadius: 20, padding: '2px 8px' }}>
                                                            ver todos
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="cli-td" style={{ textAlign: 'center' }}>
                                                    {propietarioBadge(el.propietario)}
                                                </td>
                                                <td className="cli-td" style={{ textAlign: 'center' }}>
                                                    {!el._todos && (
                                                        <button className="btn-edit" onClick={() => this.props.updateElementClicked(el.id)}>✏️</button>
                                                    )}
                                                </td>
                                                {AuthenticationService.haveAuthorization("DELETE_CLIENTES") && (
                                                    <td className="cli-td" style={{ textAlign: 'center' }}>
                                                        {!el._todos && (
                                                            <button className="btn-del" onClick={() => this.props.deleteElementClicked(el.id)}>🗑</button>
                                                        )}
                                                    </td>
                                                )}
                                            </tr>
                                        )
                                    })}
                                    {elements.length === 0 && (
                                        <tr>
                                            <td colSpan={5} style={{ textAlign: 'center', padding: '48px 0', color: '#94a3b8', fontSize: '0.85rem' }}>
                                                Sin proyectos registrados
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Paginación */}
                        {totalPages > 1 && (
                            <div style={styles.pagination}>
                                <span style={styles.pageInfo}>
                                    Mostrando {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, allRows.length)} de {allRows.length}
                                </span>
                                <div style={{ display: 'flex', gap: 4 }}>
                                    <button className="page-btn" onClick={() => this.setState({ currentPage: 1 })} disabled={page === 1}>«</button>
                                    <button className="page-btn" onClick={() => this.setState({ currentPage: page - 1 })} disabled={page === 1}>‹</button>
                                    {getPageNumbers(page, totalPages).map((p, i) =>
                                        p === '...'
                                            ? <span key={i} style={{ padding: '0 4px', alignSelf: 'center', color: '#94a3b8' }}>…</span>
                                            : <button key={p} className={`page-btn${page === p ? ' active' : ''}`} onClick={() => this.setState({ currentPage: p })}>{p}</button>
                                    )}
                                    <button className="page-btn" onClick={() => this.setState({ currentPage: page + 1 })} disabled={page === totalPages}>›</button>
                                    <button className="page-btn" onClick={() => this.setState({ currentPage: totalPages })} disabled={page === totalPages}>»</button>
                                </div>
                            </div>
                        )}
                    </div>

                    {this.state.message && (
                        <div style={{ marginTop: 12, padding: '12px 16px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 10, color: '#16a34a', fontSize: '0.85rem' }}>
                            {this.state.message}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

function getPageNumbers(current, total) {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1)
    if (current <= 4) return [1, 2, 3, 4, 5, '...', total]
    if (current >= total - 3) return [1, '...', total - 4, total - 3, total - 2, total - 1, total]
    return [1, '...', current - 1, current, current + 1, '...', total]
}

const badgeStyle = {
    fontSize: '0.72rem', fontWeight: 700, padding: '3px 12px',
    borderRadius: 20, border: '1px solid', letterSpacing: '0.5px',
}

const styles = {
    root: { minHeight: '100vh', background: '#f1f5f9', padding: '28px', fontFamily: "'Inter', sans-serif" },
    inner: { maxWidth: 800, margin: '0 auto' },
    pageHeader: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 20, flexWrap: 'wrap', gap: 12 },
    pageTitle: { margin: '0 0 4px', fontSize: '1.5rem', fontWeight: 700, color: '#0f172a' },
    pageSubtitle: { margin: 0, fontSize: '0.82rem', color: '#94a3b8' },
    btnAdd: { padding: '9px 18px', background: 'linear-gradient(135deg, #2563eb, #3b82f6)', border: 'none', borderRadius: 10, color: 'white', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', boxShadow: '0 4px 12px rgba(59,130,246,0.3)', fontFamily: "'Inter', sans-serif" },
    searchWrap: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, padding: '16px 20px', marginBottom: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    searchIcon: { position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: '0.85rem', pointerEvents: 'none' },
    tableCard: { background: 'white', border: '1px solid #e8edf5', borderRadius: 16, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' },
    pagination: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 20px', borderTop: '1px solid #f1f5f9', flexWrap: 'wrap', gap: 10 },
    pageInfo: { fontSize: '0.78rem', color: '#94a3b8' },
}

export default ClienteComponent
